{
  "error": "Erreur",
  "try_again": "Veuillez réessayer",
  "welcome": "Bienvenue",
  "version": "Version",
  "error_network_request_failed": "Erreur de connexion",
  "error_check_internet": "Veuillez vérifier la connexion Internet.",
  "login": "Enregistration",
  "logout": "Déconnexion",
  "cancel": "Annuler",
  "ok": "Ok",
  "yes": "Oui",
  "no": "Non",
  "password": "Mot de passe",
  "e-mail": "E-mail",
  "error_login_failed": "L’enregistration a échoué ",
  "skip": "Ignorer",
  "error_no_connection_to_server": "Aucune connexion avec le serveur.",
  "step": "Étape",
  "not_available": "Non disponible",
  "error_could_not_save_reservation": "La réservation n’a pas pu être enregistrée.",
  "error_problem_with_reservation": "Il y a eu un problème avec la réservation.",
  "rent_now": "Louer maintenant",
  "check_again": "Vérifier à nouveau",
  "service": "Commande",
  "error_general_error": "Une erreur s’est produite !",
  "error_try_again": "Une erreur s’est produite, veuillez réessayer.",
  "end": "Fin",
  "end_now": "Quitter maintenant",
  "hi": "Bonjour",
  "bye": "Au revoir",
  "english": "Anglais",
  "german": "Allemand",
  "loading": "Chargement en cours",
  "created_date": "Date de création",
  "created_at": "Créé le",
  "last_modified_at": "Dernière modification le",
  "remove": "Effacer",
  "dashboard": "Tableau de bord",
  "fleet": "Contingents",
  "users": "Utilisateur",
  "username": "Nom d’utilisateur",
  "my_inbooma": "Mon Inbooma",
  "reservation": "Réservation",
  "orders": "Commandes",
  "toggle_${a}_view": "Ouvrir la vue-${a}.",
  "list": "Liste",
  "calendar": "Calendrier",
  "customer": "Utilisateur",
  "contingent": "Contingent",
  "order": "Commande",
  "id": "Identifiant",
  "new_${a}": "Nouveau ${a}",
  "edit_${a}": "Modifier ${a}",
  "send_${a}": "Envoyer ${a}",
  "toggle_${a}": "Aller à ${a}",
  "No device token": "Aucun jeton d'appareil",
  "open_filter_menu": "Ouvrir les filtres",
  "repeat": "Répéter",
  "repeat every": "Répéter chaque",
  "day": "Jour",
  "week": "Semaine",
  "month": "Mois",
  "year": "Année",
  "schedule send": "Planifier l'envoi",
  "pick date & time": "Choisir la date et l'heure",
  "close schedule dialog": "Fermer la boîte de dialogue de planification",
  "confirmed": "Confirmé",
  "name": "Nom",
  "location": "Lieu\n",
  "description": "Description ",
  "notifications": "Notifications",
  "sms": "Sms",
  "push": "Pousser",
  "open": "ouverte",
  "resource": "Ressource",
  "close_window": "Fermer la fenêtre",
  "list_of_locations": "Liste des lieux",
  "no_locations_yet": "Vous n’avez pas encore indiqué de lieu.",
  "declined": "Refusé",
  "no_linked_reservations": "Pas de réservations reliées",
  "linked_reservations": "Réservations reliées",
  "edit": "Traiter",
  "delete": "Effacer",
  "date": "Date",
  "object": "Objet",
  "nights": "Nuits",
  "status": "Statut",
  "subject": "Objet",
  "content": "Contenu",
  "message_status": "Statut",
  "more": "More",
  "price": "Prix",
  "staff": "Collaborateur",
  "all": "Tous",
  "upcoming": "À venir",
  "past": "Passé",
  "dates": "Dates",
  "valid_from": "de",
  "valid_to": "jusqu'à",
  "paystate": "État du paiement",
  "resourcetype": "Type",
  "paid": "Payé",
  "partly_paid": "Payé partiellement",
  "unpaid": "Non payé",
  "cancel_reservation": "Annuler",
  "back_to_overview": "Retour au sommaire",
  "quick_actions": "Effectuer des actions",
  "filter_by_role": "Filtrer par rôle",
  "role": "Rôle",
  "role_admin": "Administrateur",
  "user": "Utilisateur",
  "role_user": "Utilisateur",
  "role_client": "Utilisateur/client",
  "role_superadmin": "Superadministrateur",
  "user_role": "Rôle de l’utilisateur",
  "user_sidebar_tip_box": "Configurez les rôles ou ceux déjà existants pour vous assurer que vos données restent protégées.",
  "active": "Actif",
  "inactive": "Inactif",
  "defect": "Défectueux",
  "save": "Enregistrer",
  "contingents": "Contingents",
  "scheduled": "Prévue",
  "draft": "Brouillon",
  "sent": "Envoyée",
  "send": "Envoyer",
  "messages": "Messages",
  "message_draft": "Brouillon",
  "message_sent": "Envoyèrent",
  "message_success": "succès",
  "message_paused": "En pause",
  "message_failed": "Échoué",
  "message_trash": "Ordures",
  "message_scheduled": "Prévue",
  "success": "Réussite",
  "close multiple recipients dialog": "Fermer la boîte de dialogue de plusieurs destinataires",
  "open profile": "Profil ouvert",
  "change_language": "Sélectionner la langue",
  "schedule for later": "Planifier pour plus tard",
  "no_linked_resources": "Pas de ressources reliées",
  "linked_resources": "Ressources reliées",
  "battery_condition": "Niveau de la batterie",
  "open_external_link": "Ouvrir le lien externe",
  "mac_adress": "Serrure du login",
  "vehicles_active": "Objet(s) à louer ",
  "contingent_name": "Nom du contingent",
  "resources_amount": "Nombre des ressources",
  "autogenerate_resources": "Générer automatiquement les ressources ?",
  "start": "Départ",
  "add_${a}": "Ajouter ${a}",
  "contingent_label": "Identifiant contingent",
  "linked_orders": "Commandes",
  "manage_roles": "Traiter les rôles",
  "box": "Boîte",
  "select_user_role": "Sélectionne le rôle de l’utilisateur",
  "user not found": "Utilisateur non trouvé",
  "please add user to this group": "Veuillez ajouter des utilisateurs à ce groupe",
  "user_title": "Civilité",
  "user_title_mr": "Monsieur",
  "you can only send notification to one usergroup": "Vous ne pouvez envoyer une notification qu'à un seul groupe d'utilisateurs",
  "user_title_mrs": "Madame",
  "first_name": "Prénom",
  "last_name": "Nom",
  "user_active": "Utilisateur actif ?",
  "longitude": "Longitude",
  "latitude": "Latitude",
  "geofence": "Géorepérage (alentour)",
  "order_nbr": "N° de commande",
  "open_profile": "Ouvrir le profil",
  "appointment": "Date",
  "appointments": "Dates",
  "adult": "Adulte",
  "adults": "Adultes",
  "child": "Enfant",
  "children": "Enfants",
  "save_${a}": "Enregistrer ${a} ",
  "total_price": "Prix total",
  "updated_${a}": "${a} actualisé",
  "user_info_after_save": "Lorsqu’une adresse e-mail a été indiquée, nous envoyons le mot de passe temporaire à cette adresse. ",
  "choose_existing_customer": "Sélectionne l’utilisateur/client enregistré",
  "add_${a}_first": "Créer au préalable ${a} ",
  "select_element": "Marque l’objet",
  "send_feedback": "Envoyer un commentaire",
  "profile": "Profil",
  "reservations": "Réservations",
  "selected_${a}": "${a} sélectionné",
  "delete_${a}": "Effacer ${a} ",
  "change_status_to": "Modifier le statut",
  "required": "Nécessaire",
  "reservation_status": "Statut de la réservation",
  "requested": "Demandé",
  "admin": "Administrateur",
  "save_next_step": "Enregistrer &amp; aller à l’étape suivante",
  "vehicle_inactive": "Véhicule(s) inactif(s)",
  "monday": "Lundi",
  "tuesday": "Mardi",
  "wednesday": "Mercredi",
  "thursday": "Jeudi",
  "friday": "Vendredi",
  "saturday": "Samedi",
  "sunday": "Dimanche",
  "event_title": "Nom de l’événement",
  "single_appointment": "Rendez-vous individuel",
  "recurring_appointment": "Rendez-vous récurrent",
  "repeat_every_after": "Répète-les tous",
  "week(s)": "Semaine(s)",
  "month(s)": "Mois",
  "year(s)": "Année(s)",
  "optional": "En option",
  "till": "jusqu'à",
  "really_remove": "Souhaitez-vous vraiment effectuer cette action ? ",
  "recurring": "récurrent",
  "reschedule_appointment": "Changer la date du rendez-vous",
  "no data available": "Pas de données disponibles",
  "o_clock": "Heure",
  "form_validation_error": "Erreur de validation - veuillez remplir tous les champs marqués.",
  "request_error": "Problème de serveur - veuillez recharger la page ou réessayer plus tard.",
  "filter_selected": "Sélectionner le filtre",
  "prices": "Prix",
  "radius_in_meter": "Rayon en m",
  "no_contingents_yet": "Pas de contingent",
  "app_msg_page_not_found": "Page non trouvée.",
  "app_msg_page_not_found_body": "Souhaitez-vous <a href=\"#\" onclick=\"javascript:window.history.back();return false;\">revenir à l’étape précédente</a>?!",
  "app_msg_collection_empty": "Aucun résultat trouvé.",
  "app_msg_collection_empty_body": "Enlever les filtres éventuels ou saisissez de nouvelles données.",
  "app_msg_access_error": "Accès refusé.",
  "app_msg_access_error_body": "Votre rôle ne vous permet pas de consulter cette page.",
  "app_msg_error": "Problème de connexion.",
  "app_msg_error_body": "Veuillez contrôler la connexion Internet ou essayez <a href=\"#\" onclick=\"javascript:window.location.reload();return false;\">de charger de nouveau cette page</a>.",
  "manager": "Gérant",
  "role_manager": "Gérant",
  "app_msg_orders_intro": "Commandes &amp; réservations",
  "app_msg_orders_intro_body": "Plusieurs réservations liées à un même utilisateur peuvent être réunies dans une seule commande. Cela permet d’établir une liste claire des factures et des paiements.",
  "app_msg_orders_intro_action": "<strong>Sélectionnez un utilisateur/client</strong> pour aller à l’étape suivante.  <a href=\"#\" class=\"hide close-callout\">Ne pas montrer à nouveau.</a>",
  "saved_${a}": "${a} enregistré",
  "autogenerate_resources_body": "Créer des ressources pouvant être commandées pour ce contingent (conseillé)",
  "participants_amount": "Nombre de participants",
  "removed_${a}": "${a} effacé",
  "resource_secret": "Code secret",
  "action_logged_out": "Vous vous êtes déconnecté avec succès.",
  "action_logged_out_expired_token": "Votre séance a expiré. ",
  "customers": "Client",
  "created": "établi",
  "empty_locations_teaser_body": "Un lieu peut être relié à différents contingents.",
  "locations": "Lieux",
  "max_${a}_pers": "max. ${a} pers.",
  "select_${a}": "Sélectionner ${a} ",
  "reset_filter": "Annuler les filtres",
  "notes": "Notes",
  "no_special_char_allowed": "min. 3 caractères ; pas de caractères spéciaux ou espaces",
  "reservation_error_missing_begin": "La valeur de départ est manquante.",
  "reservation_error_missing_end": "La valeur de fin est manquante.",
  "invalid_time_format": "Format date/heure invalide",
  "reservation_error_start_bigger_than_end": "La date de fin doit être située après la date de départ.",
  "app_msg_empty_order": "Aucune réservation n’a encore été liée à cette commande.",
  "user_error_unique_username": "Ce nom d’utilisateur est déjà existant.",
  "completed": "Terminé",
  "added_${a}": "${a} ajouté",
  "app_msg_contingents_intro": "Contingents &amp; ressources",
  "app_msg_contingents_intro_body": "Les contingents peuvent être les véhicules, les dates ou autres entités pouvant être réservées dans une quantité maximale. Dans le cas où votre tarif Inbooma contient une application, ces chiffres peuvent être transformés en ressources réelles et étendus par le numéro d’identification des véhicules, des noms ou des codes d’accès.",
  "app_msg_users_intro": "Gestion des clients &amp; des collaborateurs",
  "app_msg_users_intro_body": "Chacun de vos clients peut être consulté et traité dans cette liste.  D’autre part, il est possible d’attribuer à chaque nouvel utilisateur un rôle d’ <strong>administrateur, de gestionnaire ou de client/utilisateur</strong>.",
  "user_registration_mail_sent": "Un e-mail de confirmation d’inscription a été envoyé.",
  "change_bookable_resources": "Adapter les ressources pouvant être commandées.",
  "number_total": "Nombre total",
  "number_active": "Ressources pouvant être commandées",
  "action_welcome_successfully_registered": "Bienvenue sur Inbooma ! Votre compte a été enregistré avec succès.",
  "appointments_error_no_contingent": "Aucun contingent du type « rendez-vous » n’a été trouvé. Le créer maintenant ?",
  "day_on": "le",
  "reservations_error_no_contingents": "Aucun contingent n’a été trouvé. Souhaitez-vous en créer un ?",
  "abort": "Annuler",
  "reservation_ended_not_editable": "L’état de la commande ne peut être modifié parce que la commande est déjà achevée.",
  "contingent_warning_too_less_total": "Attention : une quantité supérieure de ressources à celles indiquées dans le contingent a été créée.  Veuillez augmenter le nombre total en cliquant sur la barre inférieure orange. ",
  "tour_in_progress": "Course en route",
  "app_order_bike_tour_${a}": "Réservation par l’application (${a} x 1)",
  "user_title_family": "Famille",
  "user_title_company": "Entreprise",
  "order_successfully_executed": "Un e-mail avec la confirmation de la commande a été envoyé à l’utilisateur. ",
  "execute_order": "Confirmer la commande",
  "order_executed_at": "Confirmation de commande envoyée le",
  "user_error_unique_mail": "Cette adresse e-mail est déjà utilisée",
  "execute_order_body": "Envoi de l’e-mail «confirmation de commande»",
  "submit_order_status": "Envoyer le statut de la commande",
  "submit_order_status_body": "Envoi de l’e-mail « statut de la commande »",
  "order_status_successfully_submitted": "Un e-mail avec le statut actuel de la commande a été envoyé à l’utilisateur.",
  "user_activcurrentTargete_body": "Les utilisateurs inactifs ne peuvent pas se connecter.",
  "create_ics": "Données ICS",
  "create_ics_all_orders": "Créer des données ICS pour toutes les commandes",
  "resource_not_configured_yet": "La ressource n’est pas configurée.",
  "location_error_geofence_number": "Le champ Géorepérage doit contenir un nombre.",
  "street": "Rue",
  "house_nbr": "Numéro",
  "zip": "Code Postal",
  "city": "Localité",
  "phone_nbr": "Téléphone",
  "repeat_password": "Confirmer le mot de passe",
  "register": "Enregistrer",
  "registration": "Inscription",
  "deleted_resource": "Ressources effacées",
  "pricetype": "Type de prix",
  "pricetypes": "Types de prix",
  "pricetariff": "Tarif des prix",
  "pricetariffs": "Tarifs des prix",
  "price_standard": "Standard",
  "warning_prices_not_complete": "Attention: un prix n’a pas été fixé pour tous les jours de la semaine. Souhaitez-vous quand même continuer ?",
  "price_total": "Prix total",
  "reservation_error_no_pricetariffs_for_${a}": "Aucun prix n’a été fixé pour ce contingent.  <a href=\"/contingents/${a}/prices\">Ajouter des tarifs.</a>",
  "price_error_select_values_first": "Sélectionnez un contingent, une date de départ et de fin pour générer un prix. ",
  "price_error_fetch": "Problème de connexion. Veuillez réessayer plus tard. ",
  "price_error_no_prices_found_for_tariff": "Aucun prix n’a été trouvé pour ce tarif. ",
  "reschedule": "Modifier l’heure",
  "${a}_of_${b}_booked": "${a} sur ${b} places ont été commandées",
  "calendars_info_text": "Le calendrier sert à regrouper les contingents de types «rendez-vous» similaires. Après avoir créé un calendrier, vous pouvez lui attribuer des contingents et créer des événements.",
  "remove_contingent_from_calendar": "Effacer les contingents du calendrier",
  "calendars": "Calendrier",
  "close_notification": "Fermer les notifications",
  "prices_begin_info": "Début des prix saisonniers",
  "prices_end_info": "Fin des prix saisonniers",
  "locations_description_field_info": "p.ex. «proche de la gare RER»",
  "price_default_info": "Ce champ peut être laissé vide si vous préférez fixer des prix dépendants des jours de la semaine.",
  "toggle_event_blocked": "Fixer le rendez-vous / annuler le rendez-vous",
  "confirm_set_blocking": "Souhaitez-vous vraiment convenir d’un rendez-vous à cette date ?",
  "event_confirm_unset_blocking": "Souhaitez-vous vraiment annuler le rendez-vous à cette date ?",
  "event_set_blocking": "Le rendez-vous a été enregistré.",
  "event_removed_blocking": "Vous pouvez à nouveau fixer le rendez-vous.",
  "unset_reschedule": "Annuler les modifications",
  "success_saved_rescheduling": "Le rendez-vous a été modifié.",
  "success_removed_rescheduling": "Le rendez-vous a été modifié.",
  "select_appointment": "Choisis le rendez-vous",
  "person_s": "Personne(s)",
  "C_6_fleet": "Contingents",
  "error_events_found_no_calendar": "Vous n’avez pas encore relié de calendrier à ce contingent. Souhaitez-vous établir ce lien maintenant ?",
  "status_booking_process": "Démarrage en cours",
  "max_pers_count": "Nombre de personnes maximal",
  "max_pers_count_help": "Le nombre de participants éventuels et déjà inscrits ne doit pas être dépassé.",
  "open_link": "Ouvrir le lien",
  "dsgvo_accept_label": "J’accepte la politique de confidentialité",
  "cancelled": "Annulé",
  "inprogress": "Démarrage en cours",
  "language": "Langue",
  "payments": "Paiements",
  "overview": "Récapitulatif",
  "finances": "Finances",
  "reference_id": "ID de référence",
  "price_origin_${a}": "Origine du paiement : ${a}",
  "amount": "Montant",
  "account": "Compte bancaire",
  "transactions": "Transactions",
  "we_charge_you_following_positions": "Nous vous facturons les sommes suivantes",
  "net": "net",
  "gross": "brut",
  "ust": "Impôt sur le chiffre d’affaires",
  "ust_sentence": "Taux de l’impôt sur le chiffre d’affaires",
  "complete": "Montant de la facture",
  "invoice_nbr": "N° de la facture",
  "message_nbr": "N° message",
  "gesamt": "Total",
  "check_payment": "Marquer comme payé",
  "print": "Imprimer",
  "times": "Durée réservée",
  "includes": "inclus",
  "mwst": "TVA",
  "invoice": "Facture",
  "invoice_for": "Facture pour",
  "create_invoice": "Rédiger une facture",
  "check_your_inbox": "Merci de ton inscription.",
  "a_confirmation_mail_was_sended": "Un e-mail vous a été envoyé à l’adresse indiquée pour confirmer votre inscription. Dans le cas contraire, merci de consulter tes spams.",
  "welcome_to_inbooma": "Bonjour",
  "email_has_been_confirmed": "L’adresse e-mail ainsi que l’inscription du compte ont été confirmées avec succès.",
  "login_now": "S’inscrire",
  "notification": "Notification",
  "to": "Envoyer à",
  "recipient": "Destinataire",
  "enter a subject": "Entrez un sujet",
  "choose recipients...": "Choisir les destinataires...",
  "choose type of recipient": "Choisir le type de destinataire",
  "choose type of notification": "Choisir le type de notification",
  "userID": "ID de l'utilisateur",
  "userGroup": "Groupes d'utilisateurs",
  "allUsers": "tous les utilisateurs",
  "toast": "Message de pain grillé",
  "popup": "Message contextuel",
  "subject of message is required": "l'objet du message est requis",
  "type of recipient is required and must be one of the following values: userID, userGroup, allUsers": "Le type de destinataire est obligatoire et doit être l'une des valeurs suivantes : ID utilisateur, groupe d'utilisateurs, tous les utilisateurs",
  "display of notification is required and must be one of the following values: toast, popup": "L'affichage de la notification est obligatoire et doit prendre l'une des valeurs suivantes : pain grillé, pop-up",
  "list of recipients must have at least 1 item": "La liste des destinataires doit contenir au moins 1 élément",
  "list of recipients is required": "La liste des destinataires est requise",
  "content of message is required": "Le contenu du message est requis",
  "must be positive": "doit être positif",
  "schedule recurrence must be one of the following values: day, week, month, year": "La récurrence de la planification doit être l'une des valeurs suivantes : jour, semaine, mois, année",
  "multiple": "Plusieurs",
  "user ${a} added to recipient field, please add another user": "Utilisateur ${a} ajouté au champ destinataire, veuillez ajouter un autre utilisateur",
  "user group ${a} does not exist, please enter a valid user group": "Le groupe d'utilisateurs ${a} n'existe pas, veuillez saisir un groupe d'utilisateurs valide",
  "user group ${a} added to recipient field, please add another user group": "Le groupe d'utilisateurs ${a} a été ajouté au champ du destinataire, veuillez ajouter un autre groupe d'utilisateurs",
  "user ${a} does not exist, please enter a valid user": "L'utilisateur ${a} n'existe pas, veuillez entrer un utilisateur valide",
  "delete message successfully": "supprimer le message avec succès",
  "delete message unsuccessfully": "supprimer le message sans succès",
  "click to remove this recipient": "Cliquez pour supprimer ce destinataire",
  "username_to_short": "Nom d’utilisateur trop court !",
  "stay_logged_in": "Rester connecté ?",
  "timespan": "Temps",
  "reset_password": "Annuler le mot de passe",
  "forgot_password": "Modifier le mot de passe",
  "made_width": "Développé avec",
  "enter some contents in here": "Entrez du contenu ici...",
  "send message": "Envoyer le message",
  "mobile_app": "Application mobile",
  "please_enter_email": "Votre e-mail de compte inbooma",
  "email_to_short": "Adresse e-mail trop courte !",
  "next_step": "Suivant",
  "password_to_short": "Mot de passe trop court !",
  "unknown_email_address": "Adresse e-mail inconnue !",
  "please_check_email": "Veuillez consulter dans votre boîte e-mail le message d’activation de votre compte.",
  "back_to_login": "Retourner à la page de connexion",
  "data_protection_agreement": "Accord de protection des données personnelles",
  "order_cancelled_success_transactions": "Dans le cadre de la commande désormais annulée, un paiement a déjà été comptabilisé. Celui-ci n’est pas remboursé automatiquement.",
  "order_cancelled_success": "La commande a été annulée avec succès. ",
  "payout_form": "Versement",
  "confirm_payout": "Confirmer le versement",
  "payout_amount_help": "Veuillez séparer les sommes par un point, par ex. 120.30",
  "booking_activity": "Activité de réservation",
  "${a}_days": "${a} jours",
  "payment_account": "Compte bancaire",
  "payment_accounts": "Comptes bancaires",
  "payment_accounts_form": "Lier un compte bancaire",
  "account_holder_name": "Propriétaire du compte",
  "account_iban_number": "IBAN",
  "account_iban_number_info": " ",
  "bank_code": "BIC",
  "bank_code_info": "En option",
  "cash": "En espèces",
  "credit_card": "Carte de crédit",
  "sepa": "SEPA",
  "pending": "En attente de paiement",
  "payout": "versé",
  "refund": "remboursé",
  "minimum_${a}_chars_required": "min. ${a} signes nécessaires",
  "both_passwords_must_be_the_same": "Les mots de passe ne correspondent pas",
  "change_password": "Modifier le mot de passe",
  "user_register_page": "Page d’inscription publique",
  "zip_code": "Code Postal",
  "email": "E-mail",
  "house_number": "Numéro",
  "notification_text": "Les champs marqués d’une* doivent être remplis",
  "agb_accept_label": "J’accepte les conditions d’utilisation",
  "invalid_username_password": "Mot de passe ou nom d’utilisateur invalide",
  "contingent_location_help": "Les ressources peuvent être ici empruntées et échangées",
  "contingent_placeholder": "p.ex. la taille standard des vélos électriques",
  "location_of_checkin": "Lieu de retrait",
  "location_of_checkout": "Lieu de retour",
  "resource_start_location": "Lieu retrait - départ",
  "facilities": "Places de stationnement",
  "facility": "Place de stationnement",
  "slot": "Station de rechargement",
  "error_code": "Code de message",
  "error_text": "Texte du message",
  "facility_modified": "Dernière modification",
  "linked_slots": "Stations de rechargement",
  "no_linked_slots": "Pas de stations de rechargement",
  "closed": "Serrure fermée",
  "charging_quality": "Qualité de chargement",
  "external_resource_id": "Numéro d’identification (ressource externe-ID)",
  "participants_bookable": "Participant pouvant être réservé",
  "discount_in_percent": "Réduction (en pourcentage)",
  "location_yet_undefined": "Lieu inconnu",
  "pricediscounts": "Réductions",
  "discount_type": "Type de réduction",
  "valid": "Valable",
  "user_discount": "Utilisateur ou Réduction client",
  "client_discount": "Réduction pour ancien client",
  "pricediscount": "Réduction",
  "app_msg_pricediscounts_intro": "Réductions",
  "app_msg_pricediscounts_intro_body": "Les réductions vous permettent d’offrir différentes réductions de prix à vos clients.",
  "discount_amount": "Montant de la réduction (en €)",
  "user_discounts": "Réductions client",
  "client_discounts": "Réduction pour ancien client",
  "discount_percent": "Montant de la réduction (en %)",
  "combineable": "Peut être combiné",
  "count_units": "Nombre",
  "booking_type": "Type",
  "phone_number": "Téléphone",
  "country": "Pays",
  "number_discounts": "Bons d’achat",
  "number_discount": "Bon d’achat",
  "discount_number": "Code du bon d’achat",
  "you_are_activated_after_registration": "Nous te demandons de patienter jusqu’à ce que ton inscription soit vérifiée et la création de ton compte validée.",
  "cannot_remove_${a}": "${a} ne peut pas être effacé parce que les droits nécessaires sont manquants.",
  "cannot_update_${a}_${b}": "Dans le cas de ${a}, le rôle ${b} n’a pas pu être créé parce que les droit nécessaires sont manquants.",
  "with_role_${r}": " Avec rôle ${r} ",
  "number_slots": "Nombre de stations de rechargement",
  "autogenerate_facility_slots": "Montant de stations de chargement à autogénérer",
  "autogenerate_facilities_body": "Les stations de chargement seront générées conformément au montant ci-dessus.",
  "make_payout": "Payer",
  "title": "Civilité",
  "The provided value is invalid": "La valeur indiquée n’est pas valable",
  "This value is already in use": "Cette valeur est déjà utilisée",
  "withdrawable_cash": "Peut être versé",
  "transactions_of_${a}": "Transactions en ${a}",
  "client_account": "Compte principal",
  "user_account": "Compte personnel",
  "payment_type": "Mode de paiement",
  "edit_profile": "Modifier le profil",
  "user_nbr": "N° d’utilisateur",
  "kunden_nbr": "N° de client",
  "logged_in_as": "Connecté en tant que",
  "username_${a}_role_${b}": "Nom d’utilisateur : ${a}, rôle : ${b}",
  "unselect_all_filter": "Effacer tous les filtres",
  "unselect_filter": "Effacer les filtres",
  "contains_reservations_from": "Contient les réservations commençant le",
  "contains_reservations_till": "Contient les réservations se terminant le",
  "my_account": "Mon compte",
  "login_submit": "S’inscrire",
  "open_order": "Ouvrir la commande",
  "domain_not_authorized": "Inscription impossible / le domaine n’est pas autorisé",
  "customer_removed": "Effacer l’utilisateur",
  "price_from": "À partir de",
  "load_more_title": "Cliquer pour charger d’autres contenus",
  "load_more": "Charger davantage",
  "contingent_removed": "Effacer le contingent",
  "payout_success": "Le versement a été effectué avec succès !",
  "payout_error_999": "L’avoir disponible est insuffisant. ",
  "duplicate": "Dupliquer",
  "duplicate_resource_info": "Copier les ressources et ajouter au contingent.",
  "duplicate_resource_success_${a}": "Une nouvelle ressource (#${a}) a été créée.",
  "order_empty_remove": "Aucune réservation n’a été effectuée dans cette commande.  Est-ce que celle-ci doit être annulée? ",
  "one_location_required": "Un lieu au minimum est nécessaire",
  "appointment_blocked_not_bookable": "[bloqué, ne peut être réservé]",
  "payment_account_save_error": "Code BIC ou IBAN incorrect",
  "Minimum eight characters, at least one uppercase letter, one lowercase letter and one number": "8 caractères minimum, dont une majuscule, une minuscule et un chiffre.",
  "sort_by_${a}": "Trier par ${a}",
  "calendar_initializing": "Calendrier en cours de chargement",
  "booking_time_differs": "Heures de retour ou de retrait différentes",
  "begin_booking": "Heure de retrait",
  "end_booking": "Heure de retour",
  "reservation_no_price": "Sans prix",
  "new_password": "Nouveau mot de passe",
  "new_password_help": "min. 8 caractères, un chiffre, une majuscule et une minuscule",
  "new_password_confirm": "Confirmer le mot de passe",
  "new_password_submit": "Modifier le mot de passe",
  "new_password_fill_out": "Les deux champs doivent être remplis",
  "password_reset_identical": "Les deux champs doivent être identiques",
  "password_reset_invalid": "Le mot de passe doit correspondre aux directives",
  "new_password_success": "Le mot de passe a été modifié avec succès!",
  "ordersForm": "Gérer la commande",
  "unknown_or_removed_user": "Utilisateur inconnu ou déjà effacé",
  "succesfully_changed_password": "Le mot de passe a été modifié avec succès!",
  "user_error_short_username": "Le nom de l’utilisateur doit contenir minimum 3 et maximum 50 caractères et ne doit pas contenir de caractères spéciaux.",
  "email_format_not_valid": "Veuillez indiquer une adresse e-mail valide.",
  "tarif": "Tarif",
  "tarifpreis": "Prix du tarif",
  "rabatt": "Réduction",
  "mietpreis": "Prix de la location",
  "units_available": "Unité(s) sélectionnées",
  "add_unit": "Ajouter une unité",
  "no_discount_selected": "Aucune réduction sélectionnée",
  "action_conflict_less_selected_than_before": "Les prix déjà configurés peuvent être éventuellement perdus",
  "action_unset_whole_contingent": "Les prix déjà configurés sont perdus",
  "warning_no_contingent_unit_available": "En ce moment, aucune unité n’est disponible",
  "${a}_contingents_added": "${a} unité(s) ajoutée(s)",
  "${a}_contingents_deleted": "${a} unité(s) effacée(s)",
  "filter_by_contingent_name": "Chercher avec un nom...",
  "notes_external": "Remarque de l’utilisateur/du client",
  "notes_internal": "Note interne",
  "user_state_updated": "Statut de l’utilisateur actualisé.",
  "select_unselect_contingent": "Cliquer pour sélectionner / annuler le contingent",
  "opening_times_for": "Heures d’ouverture pour",
  "no_opening_times": "Heures d’ouverture non indiquées.",
  "form_validation_error_contingent_form": "Veuillez indiquer l’heure, les stations et les contingents. ",
  "a_password_reset_mail_was_sended": "Un e-mail a été envoyé à ton adresse pour réinitialiser le mot de passe.  Dans le cas contraire, merci de consulter tes spams.",
  "account_yet_unconfigured": "Le compte n’a pas été créé",
  "warning_reservation_in_progress": "Attention : des réservations non enregistrées sont encore ouvertes. Merci de d’abord enregistrer ou interrompre la réservation.",
  "in_days": "en jours",
  "ruecktransport": "Transport retour",
  "continue": "Suivant",
  "save_booking": "Créer la commande",
  "loading_return_stations_progress": "Charger les stations de retour...",
  "no_return_station_found": "Aucune station de retour trouvée",
  "de_DE": "Allemand",
  "en_GB": "Anglais",
  "quick_form_step_1": "Références de la réservation",
  "quick_form_step_2": "Données de l’utilisateur",
  "role_manager-location": "Gérant de la station",
  "add_existing_user": "Sélectionner l’utilisateur disponible",
  "before_editing": "Avant les changements",
  "action_requires_booking_save": "Sauvegarder la réservation afin de valider les changements",
  "location_list_manager": "Gérant de la station",
  "location_list_manager_help": "Nécessaire seulement quand le rôle « gérant de la station » est sélectionné.",
  "username_or_mail": "Adresse e-mail ou nom d’utilisateur",
  "fr_FR": "Français",
  "remove_booking_first_to_edit": "Pour modifier la station de retrait, veuillez annuler la réservation existante et créer une nouvelle réservation.",
  "Fahrzeuge": "Véhicules",
  "Bikesharing": "Partage de vélo",
  "Termine": "Rendez-vous",
  "reservation_unsaved": "Non sauvegardé",
  "user_has_newsletter": "Newsletter acceptée",
  "user_privacy_accepted_yes": "Politique de confidentialité acceptée le",
  "user_privacy_accepted_no": "Politique de confidentialité pas encore acceptée ",
  "user_customer_nbr": "Numéro de membre",
  "valid_from_date": "Valide à partir du/le",
  "no_contingents_available": "Aucun contingent disponible.",
  "add_empty_user": "Réinitialiser le formulaire",
  "checkin_reservation": "Check-in",
  "checkout_reservation": "Check-out",
  "checkin_search_placeholder": "Filtrer par nom, ID ou numéro d’entreprise",
  "submit_checkin": "Terminer l’enregistrement",
  "submit_checkout": "Terminer la désinscription",
  "checked_in_contingents": "Contingents enregistrés",
  "checkin_add_elements_to_cart": "Sélectionner des ressources sur la liste afin de les ajouter lorsque vous vous enregistrez.",
  "checkin_submit_error_empty": "Veuillez d’abord ajouter des ressources à la liste d’enregistrement.",
  "checkin_submit_success": "Toutes les ressources sélectionnées ont été correctement vérifiées. La réservation est maintenant terminée.",
  "checkin_remove_from_selection": "Enlever de la sélection",
  "checkin_add_to_selection": "Enregistrer les ressources",
  "checkin_comment_placeholder": "Faire un commentaire",
  "checkout_comment_placeholder": "Retirer un commentaire",
  "checkin_resources_total": "À sélectionner",
  "checkin_resources_selected": "Sélectionné",
  "checked_in_at": "Enregistré le : ",
  "available": "Disponible",
  "voucher": "Bon d’achat",
  "vouchers": "Bons d’achat",
  "voucher_type": "Type de bon",
  "voucherTypes": "Types de bons",
  "voucher_types": "Types de bons",
  "voucher_type_discount": "Réduction",
  "voucher_type_gift_card": "Bon-cadeau",
  "voucher_unit": "Unité",
  "voucher_type_id": "N° type de bon",
  "voucher_unit_percentage": "Pourcentage",
  "voucher_unit_fix_price": "Prix fixe",
  "voucher_unit_contingent": "Contingent",
  "voucher_value": "Valeur",
  "voucher_value_is_nan": "La valeur n’est pas un nombre",
  "vouchersForm": "Formulaire de bon",
  "tab_discount": "Bons de réduction",
  "tab_gift_card": "Bons-cadeaux",
  "multiple_use": "Valable plusieurs fois",
  "discount_vouchers": "Bons de réduction",
  "type": "Taper",
  "sellable": "Peut être vendu",
  "unknown_or_removed_voucher": "Inconnu ou supprimé",
  "voucher_codes": "Codes du bon d’achat",
  "voucher_codes_source": "Créer les codes",
  "voucher_codes_enter_as_text": "Entrer les codes",
  "voucher_codes_upload_file": "Télécharger le fichier",
  "voucher_codes_generate": "Générer de manière aléatoire",
  "voucher_codes_generate_count": "Nombre de codes",
  "voucher_codes_already_exist_${a}": "Ce code est déjà utilisé",
  "codes_file": "Sélectionner le fichier",
  "select_xlsx_file": "Dossier : XLS/XLSX/CSV",
  "enter_codes_separate_by": "avec ; séparer",
  "code": "Code",
  "codes": "Codes",
  "no_voucher_type_selected": "-",
  "invalid_codes_${a}": "Code invalide : ${a}",
  "voucher_type_valid_to": "Valide jusqu’au",
  "days_number": "Nombre maximum de jours",
  "contingent_number": "Nombre maximum de contingents",
  "voucher_codes_none": "-",
  "voucher_codes_new": "Ajouter les codes",
  "clone": "Reproduire en double",
  "school_bonus": "Réduction pour les classes scolaires",
  "add_payment": "Paiements",
  "paymentList": "Aperçu du paiement",
  "ec_maestro": "EC/Maestro",
  "cheques": "Chèques",
  "payment_request": "Demande de paiement",
  "checkout_finished": "Vérification terminée",
  "mietvertrag": "Contrat de location",
  "mietvertrag_help": "Contrat de location à télécharger pour cette réservation.",
  "mietvertrag_download_error": "Le contrat de location n’a pas pu être généré. La commande a-t-elle déjà été traitée ?",
  "manual_override_help": "Réinitialiser le prix transcrit",
  "next_available_opening_time": "Ouvert au plus tôt à partir de/du",
  "found_invalid_voucher": "Bon d’achat invalide",
  "filter_locations_list": "Recherche de stations alentours...",
  "payment_success": "Le paiement a été enregistré avec succès.",
  "checkin_state_pending": "Enregistrement en cours",
  "checkin_state_checked_in": "Enregistrement effectué avec succès",
  "checkin_state_checked_out": "Désinscription effectuée avec succès",
  "today": "Aujourd’hui",
  "voucher_type_status_updated": "Statut du type de bon mis à jour.",
  "contingent_empty": "Aucune ressource disponible",
  "edited_by": "de",
  "help": "Aide",
  "daily_rental_contract": "Contrats de location à la journée",
  "rental_contract_type": "Type de contrat de location",
  "rental_contract_type_normal": "Normal",
  "rental_contract_type_slowup": "Slowup",
  "rental_contract_error_empty": "Aucune réservation pour ce jour",
  "rental_contract_error": "Le contrat de location n’a pas pu être généré. Veuillez réessayer plus tard.",
  "rental_contract_warning": "Attention : le contrat de location n’est pas actuel ! Merci de confirmer à nouveau la commande. Souhaitez-vous quand même continuer ?",
  "order_not_confirmed_warning": "Les modifications de la commande n’ont pas encore été confirmées !",
  "generate": "Générer",
  "for": "pour",
  "user_active_body": "Les utilisateurs inactifs ne peuvent pas se connecter.",
  "removed": "supprimé",
  "user_added_to_order": "Une nouvelle commande a été associée à cet utilisateur.",
  "Datenschutzerklärung": "Politique de confidentialité",
  "pre_booking_time": "Date limite de réservation",
  "units": "Unités de temps",
  "minutes": "Minutes",
  "hours": "Horaires",
  "days": "Jours",
  "remove_booking_first": "La réservation contient des lieux ou des contingents déjà supprimés et ne peut par conséquent pas être traitée.",
  "email_settings": "Paramètres e-mail",
  "email_setting_get_booking_info": "Conserver les informations de réservation lors de la modification du statut.",
  "user_no_mail_confirm": "Aucune adresse e-mail n’a été indiquée. Souhaitez-vous quand même continuer ?",
  "user_mail_adress_incomplete": "Il est recommandé d’indiquer une adresse e-mail.",
  "no_price_warning": "Attention : le tarif ne peut être choisi ou Prix disponible(s)",
  "app_order_bike_tour_min_${a}": "Réservation par l’appli (${a})",
  "contingent_plans": "Planifications de contingent",
  "contingent_plan": "Planification de contingent",
  "for_networks": "Pour réseau",
  "for_contingents": "Pour contingent(s)",
  "external_resource_id_short": "Numéro d'entreprise"
}
